import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type XCloseIconProps = IconProps;

/**
 * The 16px cross the design pairs with `edit-03`. `CloseIcon` is drawn in a 10px box, so scaling it
 * up to sit beside the pencil thickened its stroke by the same factor.
 */
export const XCloseIcon: FC<XCloseIconProps> = ({ iconColor = '#344054', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L4 12M4 4L12 12"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);

XCloseIcon.displayName = 'XCloseIcon';
